"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var mccListLegacy = {
    'Venda de Vestuário, Calçados, Moda': 5651,
    'Venda De Outros Produtos': 5998,
    'Salão de Beleza, Cabeleireiro, Manicure': 7230,
    'Lanchonetes / Alimentação Em Geral': 5814,
    'Outros Prestadores De Serviços': 8999,
    'Lojas Especializadas Não Listadas Anteriomente': 5999,
    'Cosméticos / Maquiagens/ Perfumes': 5977,
    'Bebidas / Bares / Depositos': 5921,
    Restaurantes: 5812,
    'Venda de Alimentos Variados, Bebidas, Restaurantes': 5499,
    'Uso Pessoal E Venda De Itens Usados': 5931,
    'Loja De Computadores, Eletrônicos E Acessórios': 5732,
    'Táxi, Motorista de Aplicativos ': 4121,
    'Oficinas Mecânicas E Acessórios': 7538,
    'Bijouterias, Joias E Acessórios': 5944,
    'Mercadinhos / Mercearias / Padarias': 5411,
    'Arte / Artesanato': 5970,
    'Artigos Para Acampamento': 5561,
    'Clínicas de Estética, Massagens': 7298,
    'Prestadores de outros serviços': 7299,
    'Loja De Atacado No Geral': 5199,
    'Lojas De Peruca': 5698,
    'Móveis E Decoração': 5712,
    Dentistas: 8021,
    'Pedreiros, Encanadores E Eletricistas': 1520,
    'Telefones E Equipamentos De Telecomun.': 4812,
    'Serviços De Limpeza': 7349,
    'Petshop, Veterinário': 5995,
    'Loja De Peças E Acessórios De Carros': 5533,
    'Vidraçaria / Serralheria / Marcenaria E Carpintaria': 1750,
    'Manutenção De Computadores': 7379,
    'Venda de Itens para Casa, Móveis, Materiais de Construção': 5039,
    Papelaria: 5943,
    'Arquitetura, Engenharia E Consultoria': 8911,
    'Loja De Utensílios Domésticos E Outros Departamentos': 5311,
    'Personal Trainer, Academia, Clubes, Spa': 7997,
    'Serviços De Buffet / Festas À Domicílio': 5811,
    'Transporte De Cargas E Mercadoria': 4214,
    'Loja De Móveis Especializada (Home Furnishing Spec.)': 5719,
    'Colégios, Cursos, Aulas Particulares': 8299,
    Fotógrafos: 7221,
    'Eventos, Shows E Música': 7922,
    'ardinagem E Paisagismo': 780,
    Médicos: 8011,
    'Advogados E Serviços Jurídicos': 8111,
    'Organizações Religiosas': 8661,
    'Medicina Em Geral E Praticantes De Serviços De Saúde': 8099,
    'Lojas De Material De Construção-Produtos Brutos (Ex: Tijolo)': 5211,
    'Jogos / Brinquedos / Recreação': 5945,
    'Automobilismo / Associações': 8675,
    Publicidades: 7311,
    'Turismo, Passeios E Agência De Viagens': 4582,
    'Loja De Atacado De Alimentos': 5300,
    'Joalheria / Pedras Preciosas / Metais': 5094,
    Floricultura: 5992,
    'Agências De Viagens (Travel Agencies)': 4722,
    'Confeitarias (Bakeries)': 5462,
    'Eletricistas E Serviços Elétricos': 1731,
    'Artigos Para Crianças E Bebês': 5641,
    'Loja De Antiguidades (Antique Shops)': 5932,
    'Hotel / Pousada / Motel': 7011,
    'Pedreiros E Serviços De Instalação': 1740,
    'Quadras De Esporte / Propaganda Esportiva': 7941,
    'Consultoria Empresarial E Serviços De Relações Públicas': 7392,
    'Educação Primária E Secundária (Elem./Sec.S.)': 8211,
    'Lojas De Eletrodomésticos': 5722,
    'ooperativa Agricolas / Associações': 763,
    'Loja De Software': 5734,
    'Serviços De Negócios': 7399,
    'Correios - Aéreo, Terrestre E Transitórios': 4215,
    'Bares, Pubs E Casa Noturnas': 5813,
    'Móveis Para Escritórios (Commercial Furniture)': 5021,
    'Conserto De Equip. Audio E Tv': 7622,
    'Serviços De Transporte': 4789,
    'Atacadistas E Distribuidores De Roupas': 5137,
    'Prest. De Serv. Para Ar Cond., Encanamento E Aquec.': 1711,
    'Computadores, Equipamentos E Softwares': 5045,
    'Banca De Jornal': 5994,
    'Corretor De Imóveis (Aluguel)': 6513,
    'Armarinhos E Lojas De Tecido': 5949,
    'Lava Jato': 7542,
    'Clubes De Compras': 7278,
    'Atrações Turísticas E Exposições': 7991,
    'Loja De Consertos Gerais E Serviços Relacionados': 7699,
    'Lojas De Diversão / Video Game / Lan House / Ciber Café': 7994,
    'Editoras - Publicações E Impressões': 2741,
    'Farmácias (Drug Stores & Pharmacies)': 5912,
    'Venda de Hardware, Computadores, Eletrônicos': 5072,
    'Lojas De Sapatos': 5661,
    'Opticians / Optical Goods / And Eyeglasses': 8043,
    'Demais Svs De Reforma E Construção Não-Classificados': 1799,
    'A/D De Suprimentos Industriais (Não Classificado Em Outro)': 5085,
    'Serviços De Programação De Computadores E Process. De Dados': 7372,
    'Serviços Gerais Para Esportes': 5941,
    'Centros De Serviços De Metais (Metal Service Centers)': 5051,
    'Serviços De Recreação E Festas': 7999,
    'Loja De Presentes': 5947,
    'Companhias De Onibus': 4131,
    'Loja De Fotografia': 5946,
    'Açogueiro (Freezer/Meat Lockers)': 5422,
    'Loja Mercadorias Gerais': 5399,
    Metalurgicos: 1761,
    'Lojas De Motocicletas E Acessórios': 5571,
    'Revendedores De Combustíveis (Fuel Dealers)': 5983,
    'Atacadistas E Distribuidores De Mercadorias Duráveis': 5099,
    'Lojas De Vidros, Tintas E Papéis De Parede': 5231,
    'A/D De Tecidos E Produtos De Armarinho': 5131,
    'Funilarias E Pintura Automotiva': 7531,
    'Conserto De Eletronicos': 7629,
    'Costureiras E Alfaiates': 5697,
    'Venda De Equipamentos, Incluindo De Ferragem': 5251,
    'Serviços Governamentais (Govt Serv - Default)': 9399,
    'Redes De Computadores / Serviços De Informação': 4816,
    'Corretores De Imóveis (Securities Brokers/Dealers)': 6211,
    'Aluguel De Equipamento E Mobília De Escritórios': 7394,
    'Loja De Bicicletas - Vendas E Serviços': 5940,
    'Fornecedores De Máquinas De Videogame Ou Jogos': 7993,
    Livrarias: 5942,
    'Organização Política Ou Beneficentes': 8398,
    Borracharias: 7534,
    Tabacaria: 5993,
    'Loja De Produtos De Lacticínios (Dairy Prod. Stores)': 5451,
    'A/D De Artigos De Papelaria E Suprimentos Para Escritório': 5111,
    'Associações Cívicas E Sociais': 8641,
    'Contabilidade, Auditoria E Serviços De Contabilidade': 8931,
    'Typesetting, Plate Making And Related Services': 2791,
    'Analises Clínicas Médicas E Dentais': 8071,
    Veterinaria: 742,
    'Loja De Doces': 5441,
    'Loja Instrumento Musicais': 5733,
    'Restauração De Móveis (Furniture Repair)': 7641,
    'Produtores E Distribuidores De Filmes': 7829,
    'Org. Sind., Assoc. Cult. E Otrs Assoc. Não Classif.': 8699,
    'Serviços De Cuidados De Crianças (Child Care Svcs)': 8351,
    'Loja De Estofados (Drapery & Upholstery Stores)': 5714,
    'Agências De Detetives, Protecção E De Segurança': 7393,
    'Oficinas, Garagens, Estacionamentos': 7523,
    'Copiadoras E Fotocopiadoras': 7338,
    'Bens Ortopédicos - Próteses': 5976,
    'Utilid./Elec/Gas/Aguá/Sani (Ut../Elec/Gas/H2O/Sani)': 4900,
    'Bandas,Orquestras,Artistas Diversos(N Classificado Em Outro)': 7929,
    'Lojas De Videos': 7841,
    'Outros Vendedores De Marketing Direto': 5969,
    'Venda De Carros Usados': 5521,
    'Escola De Comércios E Secretariado (Bus./Sec. School)': 8244,
    'Farmaceuticos/Drogas (Drugs/Druggists Sundries)': 5122,
    'Loja De Pneus': 5532,
    'Estações De Serviços (Service Stations)': 5541,
    'Aluguel De Automóveis (Automobile Rental Agency)': 7512,
    'Lavanderia Tinturaria': 7216,
    'Loja Artigos Eletrônicos': 5065,
    'Dedetização E Desinfecção': 7342,
    Hospitais: 8062,
    'Serviço Funerário': 7261,
    'Serviços De Telecomunicação': 4814,
    'A/D De Máquinas E Equipamentos Para Ec': 5046,
    'Venda De Seguros(Insurance Sales/Underwrite)': 6300,
    Guincho: 7549,
    'Aluguel De Roupas - Fantasias, Uniformes E Roupas Sociais': 7296,
    'Conserto De Relógios E Jóias': 7631,
    'Atacadistas E Distribuidores De Acessórios De Veículos': 5013,
    'A/D De Equipamento Hospitalares, Médicos E Oftálmicos': 5047,
    'Atacadistas E Distribuidores De Calçados': 5139,
    'Venda de Outros Produtos': 5331,
    'Instiuição Financeira - Agências E Serviços': 6012,
    'Serviços Gerias Para Carros': 5599,
    'Galeria De Arte (Art Dealers & Galleries)': 5971,
    'Venda De Carros E Caminhões (Novos E Usados)': 5511,
    'Serviços De Limpeza E Polimento': 2842,
    'Artigos De Couro': 5948,
    'Lojas De Pintura De Auttomóveis': 7535,
    'Escola De Negócios/Vocações (Trade/Vocations S.)': 8249,
    'Demolições / Sucatas / Desmanches De Automóveis': 5935,
    'Loja De Roupas Femininas "Pronta Para Usar"': 5621,
    'Serviço De Secretariado E Estenografia': 7339,
    'Lojas De Discos': 5735,
    'Universidades E Faculdades (Colleges/Univ/Jc/Prof.)': 8220,
    'Serviços Gerias Para Vestimenta': 5699,
    'Transporte Local De Passageiros, Incluindo Balsas': 4111,
    'Loja/Reparo De Sapatos': 7251,
    'Empreiteio Para Serviços Especializado': 1771,
    'Jardinagem E Paisagismo': 780,
    'Produtos De Petróleo (Petroleum/Petroleum Products)': 5172,
    'Agências De Análise De Crédito De Consumidores': 7321,
    'A/D De Produtos Quimicos E Semelhantes (N Classif. Em Outro)': 5169,
    'Cassinos / Loterias E Jogos De Azar': 7995,
    Osteopatas: 8031,
    'Casas De Câmbio': 6051,
    'Agências De Emprego': 7361,
    'Dança (Estudios, Escolas E Salões)': 7911,
    'Serviços De Tv A Cabo/Paga (Cable/Pay Tv Services)': 4899,
    'Navalha Elétrica - Venda E Serviços': 5997,
    'Casas De Repouso, Clín. De Recuperação E Enfermagem': 8050,
    'Atacadistas E Distribuidores De Flores, Plantas E Sementes': 5193,
    'Limpeza De Tapetes E Estofados': 7217,
    'Marinas / Serviços E Fornecedores': 4468,
    'Lavandaria, Limpeza E Serviços De Vestuário': 7210,
    'Bares De Sinuca': 7932,
    'Armazenam. Prod Agrícolas,Mercad Refrigeradas,Bens Doméstico': 4225,
    'Laboratórios Fotográficos': 7395,
    'Serviço De Encontros E Acompanhante': 7273,
    'Laboratórios De Teste (Para Testes Não Médicos)': 8734,
    'Pintura, Obras, Eletricistas, Marcenaria, Carpintaria': 5198,
    'Lojas De Material De Construção (Pequeno/Médio Porte)': 5200,
    Ambulancias: 4119,
    'Atac. E Distrib. De Livros, Periódicos E Jornais': 5192,
    'Postagens (Postage Stamps)': 9402,
    'Venda De Barcos Motorizados': 5551,
    'Serviços De Acampamentos': 7033,
    'Parque De Diversao, Circo E Afins': 7996,
    'Lojas De Desconto': 5310,
    'Organizações Politicas': 8651,
    'Parada De Caminhões (Truck Stop)': 7511,
    'Conserto De Ar Condicionado': 7623,
    'Aluguel E Arrendamento De Barcos, Esquis E Iates': 4457,
    'Aquários E Zoológicos': 7998,
    Quiropraxia: 8041,
    'Cooperativa Agricolas / Associações': 763,
    'Outras Cias Aéreas': 4511,
    'Aparelhos Auditivos - Vendas E Serviços': 5975,
    'Serviços De Prep. Impost. De Renda (Tax Prep. Svcs)': 7276,
    'Cinemas / Produções Cinematográficas': 7832,
    'Pagamentos De Impostos (Tax Payments)': 9311,
    'Linhas De Cruzeros (Cruise Lines)': 4411,
    'Roupa Esportiva': 5655,
    'Serv. Diretos De Viagens (D. Mktg-Trav. Related Arr)': 5962,
    'Marketing Direto-Saída (Outb. Telemarketing M.)': 5966,
    'Máquinas De Escrever - Venda, Aluguel E Serviços': 5978,
    'S. De Aconselhamento De Dívidas, Casamento E Pessoal': 7277,
    'Aluguel De Motor Home (Motor Home/Rv Rentals)': 7519,
    'Eduacação A Distância (Correspondence Schools)': 8241,
    'Pensão Alimentícia (Court Costs/Alimony/Support)': 9211,
    'Corretores De Residências Móveis': 5271,
    'Lareiras E Acessórios (Fireplaces & Accessories)': 5718,
    'Mark.Direto De Seguros (Dir. Market. Insurance Svc)': 5960,
    'Loja De Moedas E Selos': 5972,
    'Serviço De Recuperação De Informação': 7375,
    Boliche: 7933,
    'Oftamologista E Optometristas': 8042,
};
exports.default = mccListLegacy;
//# sourceMappingURL=mccLegacy.js.map